var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMiniColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4697 0C35.5053 0 0 0 0 0V34.5066C0 39.0287 4.99826 39.9311 5.45447 40.0048C5.49321 40.3748 6.17939 45.9505 12.4075 45.9505C15.5097 45.9505 51.2525 45.9505 51.2525 45.9505V10.0215C51.2525 3.57965 47.4354 0 41.4697 0ZM10.9677 32.733H7.41677V18.5269C7.41677 14.3573 10.9677 14.3573 10.9677 14.3573V32.7318V32.733ZM10.9752 14.3586C10.9752 14.3586 10.9752 10.8064 15.1448 10.8064H19.9943C24.1639 10.8064 24.2426 14.3586 24.2426 14.3586H10.9764H10.9752ZM27.8035 18.5269V32.733H24.2514V14.3573C24.2514 14.3573 24.2551 14.3573 24.2564 14.3573C24.2564 14.3548 24.2576 10.8052 28.426 10.8052H36.1015C40.2711 10.8052 40.2711 14.3573 40.2711 14.3573H24.2639C24.4851 14.3623 27.8035 14.4961 27.8035 18.5257V18.5269ZM43.837 32.733H40.2848V14.3573C40.2848 14.3573 43.837 14.3573 43.837 18.5269V32.733Z",
    fill: "url(#paint0_linear_10714_36024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10714_36024",
    x1: 25.6262,
    y1: -4.5758,
    x2: 25.6262,
    y2: 58.1168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EC493C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B487FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMiniColor);
export default __webpack_public_path__ + "static/media/logo-mini-color.854cc9b9052a1010df3f2cd83a764ad9.svg";
export { ForwardRef as ReactComponent };